import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleY = useSpring(scrollYProgress, { stiffness: 120, damping: 30 });
  return (
    <div
      aria-hidden="true"
      data-testid="scroll-progress"
      className="fixed right-6 md:right-10 top-1/2 -translate-y-1/2 z-40 h-40 w-px bg-white/10 hidden md:block"
    >
      <motion.div
        style={{ scaleY, originY: 0 }}
        className="h-full w-px bg-[#E5D3B3]"
      />
    </div>
  );
}
